import { useMemo } from 'react';
import mitt, { Emitter } from 'mitt';
import { CallInsightPanelSource, PanelEvents } from '../types';

const emitterMap = new Map<CallInsightPanelSource, Emitter<PanelEvents>>();

export function usePanelEmitter(source: CallInsightPanelSource): Emitter<PanelEvents> {
  return useMemo<Emitter<PanelEvents>>(() => {
    const existing = emitterMap.get(source);
    if (existing) {
      return existing;
    }
    const newEmitter = mitt<PanelEvents>();
    emitterMap.set(source, newEmitter);
    return newEmitter;
  }, [source]);
}
